/*
 * <license header>
 */

import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Hero from '../Hero/Hero'
import About from '../About/About'
import Projects from '../Projects/Projects'
import Skills from '../Skills/Skills'
import CertificationsSection from '../CertificationsSection/CertificationsSection'
import BlogSection from '../BlogSection/BlogSection'
import ContactSection from '../ContactSection/ContactSection'
import ProfileContext from '../Profile/Profile'

function App() {
  const profileInfo = null

  return (
    <ProfileContext.Provider value={profileInfo}>
      <Header />
      <main id='main-content' role='main'>
        <Hero />
        <section id="about">
          <About />
        </section>
        <section id="experience">
          <Projects />
        </section>
        <section id="skills">
          <Skills />
        </section>
        <section id="certifications">
          <CertificationsSection />
        </section>
        <section id="blogs">
          <BlogSection />
        </section>
        <section id="contact">
          <ContactSection />
        </section>
      </main>
      <Footer />
    </ProfileContext.Provider>
  )
}

export default App
